import React from 'react';
import { useTranslation } from 'react-i18next';

const OurValues = () => {
  const { t } = useTranslation(); // ✅ PAS de namespace ici

  return (
    <section className="bg-slate-100 dark:bg-gray-950 py-10">
      <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20">

        {/* Illustration de la bannière */}
        <div className="lg:w-1/2 mr-12">
          <img 
            src="/images/about.png" 
            alt="About Us" 
            className="w-full h-auto" 
          />
        </div>

        {/* Texte de la bannière */}
        <div className="lg:w-1/2 text-center lg:text-left mb-10 lg:mb-0">
          <h6 className="text-xl font-bold text-blue-600 mb-4">
            {t('OurValues.sectionTitle')}
          </h6>
          <h1 className="text-5xl font-bold text-gray-800 dark:text-gray-200 mb-4">
            {t('OurValues.title')} <span className="text-blue-600">{t('OurValues.spanTitle')}</span><br />
          </h1>

          <div className="grid grid-cols-1 gap-8 mt-2">
            <ValueCard 
              title={t('OurValues.Innovation.title')} 
              description={t('OurValues.Innovation.description')} 
            />
            <ValueCard 
              title={t('OurValues.Collaboration.title')} 
              description={t('OurValues.Collaboration.description')} 
            />
            <ValueCard 
              title={t('OurValues.Excellence.title')} 
              description={t('OurValues.Excellence.description')} 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const ValueCard = ({ title, description }) => (
  <div className="bg-white dark:bg-slate-900 shadow-md rounded-lg p-2 px-6 text-center transition-transform transform hover:scale-105">
    <h4 className="text-xl font-extrabold text-left mb-4 py-1 text-blue-600">{title}:</h4>
    <p className="text-gray-600 dark:text-gray-400 text-left mb-4">{description}</p>
  </div>
);

export default OurValues;
